import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: ReactNode;
  hint?: string;
}

export function Input({ label, icon, hint, className, id, ...props }: InputProps) {
  return (
    <label className="block text-left">
      {/* dark: classes ADDED FOR THEME */}
      {label && <span className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">{label}</span>}
      <div className="relative">
        {icon && <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">{icon}</span>}
        <input
          id={id}
          className={cn(
            'w-full rounded-xl border border-gray-300 bg-white px-3.5 py-2.5 text-sm text-gray-900 outline-none transition-colors placeholder:text-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100',
            'dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-500 dark:focus:ring-blue-500/30',
            icon && 'pl-10',
            className,
          )}
          {...props}
        />
      </div>
      {hint && <span className="mt-1 block text-xs text-gray-400 dark:text-gray-500">{hint}</span>}
    </label>
  );
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: { value: string; label: string }[];
}

export function Select({ label, options, className, ...props }: SelectProps) {
  return (
    <label className="block text-left">
      {label && <span className="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">{label}</span>}
      <select
        className={cn(
          'w-full rounded-xl border border-gray-300 bg-white px-3.5 py-2.5 text-sm text-gray-900 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100',
          'dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:focus:ring-blue-500/30', // ADDED FOR THEME
          className,
        )}
        {...props}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
